export default __webpack_public_path__ + "static/media/laundry1-afterA-1024w.410b970d.png";